import React from "react";
import PropTypes from "prop-types";
import {
  Grow,
  Paper,
  Popper,
  MenuItem,
  MenuList,
  withStyles,
  ClickAwayListener,
  Button,
} from "@material-ui/core/";
import { store } from "../../../Store/store";
import "./DropDownMenu.css";
import { COLORS } from "../../../Theme/variables";

let langData = require("../../../Data/language.json");

const styles = (theme) => ({
  root: {
    display: "block",
  },
  paper: {
    marginRight: theme.spacing.unit * 2,
    zIndex: "100",
  },
});

class AddItemToCategory extends React.Component {
  state = {
    open: false,
    selectedIndex: 0,
  };
  language = store.getState().firebase.language;

  handleToggle = () => {
    this.setState({ open: !this.state.open });
  };

  handleClose = (event, value) => {
    if (this.anchorEl.contains(event.target)) {
      return;
    } else {
      if (value === "uncategorized") {
        this.setState({ selectedIndex: 0 });
      } else if (value === "meat") {
        this.setState({ selectedIndex: 1 });
      } else if (value === "fruit") {
        this.setState({ selectedIndex: 2 });
      } else if (value === "dairy") {
        this.setState({ selectedIndex: 3 });
      } else if (value === "pantry") {
        this.setState({ selectedIndex: 4 });
      } else if (value === "premade") {
        this.setState({ selectedIndex: 5 });
      } else if (value === "drinks") {
        this.setState({ selectedIndex: 6 });
      } else if (value === "babies") {
        this.setState({ selectedIndex: 7 });
      }
      if (value !== "uncategorized") {
        this.props.updateCategory(this.props.ean, value);
        this.props.updateItem(value);
      }
    }

    this.setState({ open: false });
  };

  clickAwayHandler = () => {
    this.setState({ open: false });
  };

  render() {
    const { classes } = this.props;
    const { open } = this.state;

    return (
      <div className={classes.root}>
        <div>
          <ClickAwayListener onClickAway={this.clickAwayHandler}>
            <div>
              <Button
                className="orderButton"
                style={
                  this.state.open
                    ? {
                        border: `solid 2px ${COLORS.primary}`,
                        backgroundColor: "white",
                        paddingLeft: "8px",
                        paddingRight: "8px",
                      }
                    : {
                        backgroundColor: "white",
                        paddingLeft: "8px",
                        paddingRight: "8px",
                      }
                }
                buttonRef={(node) => {
                  this.anchorEl = node;
                }}
                aria-owns={open ? "menu-list-grow" : undefined}
                aria-haspopup="true"
                variant="contained"
                onClick={this.handleToggle}
              >
                {
                  <img
                    className="btnImage"
                    src={require("../../../Images/Icons/filterIcon.svg")}
                    alt="profileIcon"
                  />
                }
              </Button>
              <Popper
                open={open}
                anchorEl={this.anchorEl}
                transition
                disablePortal
                className="dropDown"
              >
                {({ TransitionProps, placement }) => (
                  <Grow
                    {...TransitionProps}
                    id="menu-list-grow"
                    style={{
                      transformOrigin:
                        placement === "bottom"
                          ? "center bottom"
                          : "center bottom",
                    }}
                  >
                    <Paper>
                      <MenuList>
                        <MenuItem
                          selected={this.state.selectedIndex === 0}
                          onClick={(e) => this.handleClose(e, "uncategorized")}
                        >
                          {
                            langData[this.language].list.functions.filterOptions
                              .uncategorized
                          }
                        </MenuItem>
                        <MenuItem
                          selected={this.state.selectedIndex === 1}
                          onClick={(e) => this.handleClose(e, "meat")}
                        >
                          {
                            langData[this.language].list.functions.filterOptions
                              .meat
                          }
                        </MenuItem>
                        <MenuItem
                          selected={this.state.selectedIndex === 2}
                          onClick={(e) => this.handleClose(e, "fruit")}
                        >
                          {
                            langData[this.language].list.functions.filterOptions
                              .fruit
                          }
                        </MenuItem>
                        <MenuItem
                          selected={this.state.selectedIndex === 3}
                          onClick={(e) => this.handleClose(e, "dairy")}
                        >
                          {
                            langData[this.language].list.functions.filterOptions
                              .dairy
                          }
                        </MenuItem>
                        <MenuItem
                          selected={this.state.selectedIndex === 4}
                          onClick={(e) => this.handleClose(e, "pantry")}
                        >
                          {
                            langData[this.language].list.functions.filterOptions
                              .pantry
                          }
                        </MenuItem>
                        <MenuItem
                          selected={this.state.selectedIndex === 5}
                          onClick={(e) => this.handleClose(e, "premade")}
                        >
                          {
                            langData[this.language].list.functions.filterOptions
                              .premade
                          }
                        </MenuItem>
                        <MenuItem
                          selected={this.state.selectedIndex === 6}
                          onClick={(e) => this.handleClose(e, "drinks")}
                        >
                          {
                            langData[this.language].list.functions.filterOptions
                              .drinks
                          }
                        </MenuItem>
                        <MenuItem
                          selected={this.state.selectedIndex === 7}
                          onClick={(e) => this.handleClose(e, "babies")}
                        >
                          {
                            langData[this.language].list.functions.filterOptions
                              .babies
                          }
                        </MenuItem>
                      </MenuList>
                    </Paper>
                  </Grow>
                )}
              </Popper>
            </div>
          </ClickAwayListener>
        </div>
      </div>
    );
  }
}

AddItemToCategory.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AddItemToCategory);
